/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientModel } from '../../models/patient-model';
import { PatientPrimaryPracticeModel } from '../../models/patient-primary-practice-model';

export interface PatientPrimaryPracticePost$Params {
      body?: PatientPrimaryPracticeModel
}

export function patientPrimaryPracticePost(http: HttpClient, rootUrl: string, params?: PatientPrimaryPracticePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModel>> {
  const rb = new RequestBuilder(rootUrl, patientPrimaryPracticePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientModel>;
    })
  );
}

patientPrimaryPracticePost.PATH = '/Patient/PrimaryPractice';
